<template>
  <header>
    <div class="flex">
      <h1 class="title">{{ title }} <span v-if="subtitle">{{ subtitle }}</span></h1>
      <div class="actions">
        <button v-if="showStartButton"
                class="start-run-btn"
                @click="handleStartRun"
                :class="{ 'animate': isAnimating, 'auto-mode': isAutoMode }">
          {{ startButtonText }}
          <span class="btn-glow"></span>
          <div v-if="isAutoMode" class="pill-container">
            <span class="auto-indicator">AUTO</span>
            <span v-if="countdownTime" class="countdown-pill">{{ formattedCountdown }}</span>
          </div>
        </button>
        <slot name="actions"></slot>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'raceHeader',
  data() {
    return {
      isAnimating: false,
      countdownInterval: null
    }
  },
  props: {
    title: {
      type: String,
      required: false
    },
    subtitle: {
      type: String,
      required: false
    },
    showStartButton: {
      type: Boolean,
      default: false
    },
    isAutoMode: {
      type: Boolean,
      default: false
    },
    startButtonText: {
      type: String,
      default: 'Start Run'
    },
    countdownTime: {
      type: Number,
      default: null
    }
    // ,
    // classes: {
    //   type: String,
    //   required: false
    // }
  },
  computed: {
    formattedCountdown() {
      if (!this.countdownTime) return '';
      const minutes = Math.floor(this.countdownTime / 60);
      const seconds = this.countdownTime % 60;
      return `${minutes}:${seconds.toString().padStart(2, '0')}`;
    }
  },
  methods: {
    handleStartRun() {
      this.isAnimating = true;
      this.$emit('start-run');
      setTimeout(() => {
        this.isAnimating = false;
      }, 500);
    }
  }
}
</script>

<style lang="stylus" scoped>
.flex
  display flex
  justify-content space-between
  align-items center
  padding 20px 0

.title
  margin 0
  font-size 24px
  color #333

  span
    font-size 16px
    color #666
    margin-left 10px

.actions
  display flex
  gap 15px
  align-items center

.start-run-btn
  position relative
  padding 12px 28px
  font-size 16px
  font-weight 600
  color #fff
  background linear-gradient(135deg, #4b42a3 0%, #6357c9 100%)
  border none
  border-radius 8px
  cursor pointer
  overflow hidden
  transition all 0.3s cubic-bezier(0.4, 0, 0.2, 1)
  box-shadow 0 4px 15px rgba(99, 87, 201, 0.2)

  &:hover
    transform translateY(-2px)
    box-shadow 0 6px 25px rgba(99, 87, 201, 0.4)

  &.animate
    animation pulseScale 0.5s cubic-bezier(0.4, 0, 0.2, 1)

  &.auto-mode
    background linear-gradient(135deg, #2c8af3 0%, #0056b3 100%)

    .auto-indicator
      position absolute
      top -8px
      right -8px
      background #00c853
      color white
      font-size 10px
      padding 2px 6px
      border-radius 10px
      font-weight bold
      animation fadeInDown 0.3s forwards

  .btn-glow
    position absolute
    top 0
    left 0
    width 100%
    height 100%
    background linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent)
    transform skewX(-20deg)
    animation shimmer 2s infinite

@keyframes pulseScale
  0%
    transform scale(1)
  50%
    transform scale(0.95)
  100%
    transform scale(1)

@keyframes shimmer
  from
    transform skewX(-20deg) translateX(-100%)
  to
    transform skewX(-20deg) translateX(200%)

@keyframes fadeInDown
  from
    opacity 0
    transform translateY(-10px)
  to
    opacity 1
    transform translateY(0)

.pill-container
  position absolute
  top -8px
  right -8px
  display flex
  gap 6px
  animation fadeInDown 0.3s forwards

.auto-indicator
  background #00c853
  color white
  font-size 10px
  padding 2px 6px
  border-radius 10px
  font-weight bold

.countdown-pill
  background rgba(0, 0, 0, 0.7)
  color white
  font-size 10px
  padding 2px 6px
  border-radius 10px
  font-weight bold
  font-family monospace
  min-width 40px
  text-align center
  backdrop-filter blur(4px)
  animation pulseOpacity 1s infinite

@keyframes pulseOpacity
  0%
    opacity 1
  50%
    opacity 0.7
  100%
    opacity 1
</style>



// WEBPACK FOOTER //
// Header.vue?516af295